(() => {
  const initializeLanding = () => {
    document.querySelectorAll('[data-lb-ad-product]').forEach((card) => {
      const select = card.querySelector('[data-lb-ad-variant]');
      const image = card.querySelector('.lb-ad-product__media img');
      const price = card.querySelector('[data-lb-ad-price]');
      let imageSequence = 0;

      if (!select) return;

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (image && option.dataset.image) {
          const requestedSequence = ++imageSequence;
          const requestedVariant = option.value;
          card.classList.add('is-changing');

          const nextImage = new Image();
          nextImage.onload = () => {
            if (
              requestedSequence !== imageSequence
              || select.value !== requestedVariant
            ) return;

            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = option.dataset.image;
            image.alt = option.dataset.alt || image.alt;
            card.classList.remove('is-changing');
          };
          nextImage.onerror = () => {
            if (requestedSequence === imageSequence) {
              card.classList.remove('is-changing');
            }
          };
          nextImage.src = option.dataset.image;
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLanding, { once: true });
  } else {
    initializeLanding();
  }
})();
